import { Injectable } from '@angular/core';

import { getAccessTokenPayloadInfo } from '@solvace/common/functions/token-reader';
import { SvcStoredAuthUser } from './model/svc-stored-auth-user.interface';

@Injectable({
  providedIn: 'root',
})
export class SvcStoredAuthUserService {
  readonly #storedAuthUserKey = 'SvcCacheDataUser';

  constructor() {}

  public addStoredAuthUser(cognitoAccessToken: string, cognitoSsoId: string, fullName: string, environmentUrl: string, ssoUsername?: string): void {
    const user: SvcStoredAuthUser = {
      cognitoAccessToken,
      cognitoSsoId,
      fullName,
      environmentUrl,
      userId: getAccessTokenPayloadInfo('UserId')?.toLocaleLowerCase(),
      userName: getAccessTokenPayloadInfo('User'),
      ssoUsername,
    };

    const users: SvcStoredAuthUser[] = this.getUsersLogged();

    const newUsers = users?.filter?.((storedUser) => storedUser?.userId?.toLowerCase() !== user?.userId?.toLowerCase());
    newUsers.push(user);
    this.addUsers(newUsers);
  }
  public updateStoredAuthUser(userId: string, fullName: string): void {
    const users: SvcStoredAuthUser[] = this.getUsersLogged();

    const user = users?.find((storedUser) => storedUser?.userId?.toLowerCase() === userId?.toLowerCase());
    if (!user) return;
    user.firstName = fullName;
    const newUsers = users?.filter?.((storedUser) => storedUser?.userId?.toLowerCase() !== userId?.toLowerCase());
    newUsers.push(user);
    this.addUsers(newUsers);
  }

  public removeUserByUserId(userId: string): void {
    let users = this.getUsersLogged();
    users = users?.filter((user) => user?.userId?.toLowerCase() !== userId?.toLowerCase());
    this.addUsers(users);
  }

  public getUsersLogged(): SvcStoredAuthUser[] {
    try {
      const stored = JSON.parse(localStorage.getItem(this.#storedAuthUserKey) || '[]');
      if (Array.isArray(stored)) return stored;
      return [];
    } catch {
      return [];
    }
  }

  public getUserLoggedByUserId(userId: string): SvcStoredAuthUser {
    const users = this.getUsersLogged();
    return users?.find((user) => user?.userId?.toLowerCase() === userId?.toLowerCase());
  }

  public addUsers(users: SvcStoredAuthUser[]): void {
    localStorage.setItem(this.#storedAuthUserKey, JSON.stringify(users));
  }

  public deleteAllUsers(): void {
    localStorage.removeItem(this.#storedAuthUserKey);
  }
}
